import React, { Component } from 'react'
import { browserHistory, Link } from 'react-router'
import { connect } from 'react-redux'
import cookie from 'react-cookie'
import CSSModules from 'react-css-modules'
import styles from './headerTask.css'
import { api, domen } from '../../config.js'
import ava from './imgs/ava-ph-small.png'
import Social from './Social'
class HeaderTask extends Component {

  componentDidMount () {
    window.addEventListener('click', this.handleDocumentClick)
  }

  componentWillUnmount () {
    window.removeEventListener('click', this.handleDocumentClick)
  }

  handleDocumentClick = (evt) => {
    const area = this.refs.menu;

    if (!area.contains(evt.target)) {
      this.props.dispatch({ type: 'LITTLE_HEADER_MENU', isVisible: false })
    }
  }

  renderLogo(){
    let {program} = this.props
    console.log('programmmm')
    console.log(program)
    if(!program){
      return (
        <use xlinkHref="#ys-logo-web"></use>
      )
    }
    if(program % 4 === 1){
      return (
        <use xlinkHref="#ys-logo-web-hero"></use>
      )
    }
    if(program % 4 === 2){
      return (
        <use xlinkHref="#ys-logo-web-mama"></use>
      )
    }
    if(program % 4 === 3){
      return (
        <use xlinkHref="#ys-logo-web-extreme"></use>
      )
    }
    if(program % 4 === 0){
      return (
        <use xlinkHref="#ys-logo-web"></use>
      )
    }
  }

  render() {
    const { dispatch, program, fullName, avatar, isVisible, showLeftMenu, userInfo, sign } = this.props
    const { isFirstEdit, gender} = userInfo.data
    const { host } = sign
    const isAlfa = domen.isAlfa
    let backgroundColor = styles.headerExtreme
     /* if(program % 4 === 2){
          backgroundColor = styles.headerMother
      }
      if(program % 4 === 3){
          backgroundColor = styles.headerExtreme
      }
      if(program % 4 === 0){
          backgroundColor = styles.headerTomorrow
      }

      if(isAlfa){
        backgroundColor = styles.headerAlfa
      }*/


    return (
      <div className={backgroundColor}>
        <div className={styles.gridHeaderInner}>
          <div
            className={styles.gridCellHeaderBurger33}
            onClick={showLeftMenu}
          >
            <span className={styles.headerIcoBurger}>
              <svg className={styles.svgIconBurger}>
                <use xlinkHref="#ico-burger"></use>
              </svg>
            </span>
          </div>
          {isAlfa ?
            <h1 className={styles.gridCellHeaderLogoAlfa}>
              <img src="/assets/img/alfa/logo_white.png" className={styles.alfaLogo} alt=""/>
            </h1>
            :
            <h1 className={styles.gridCellHeaderLogo33}>
              Ясегодня
             <Link to="/task">
               <svg className={styles.svgIconYsLogoWeb}>
                 {this.renderLogo()}
               </svg>
             </Link>

            </h1>
          }
          <div className={styles.socialBlock}>
            <Social/>
          </div>


          <div className={styles.gridCellHeaderRightSide33}>
            {/* <div className={styles.hNotify}>
              <div className={styles.hNotifyIco}>
                <span className={styles.hNotifyStatus}></span>
                <svg className={styles.svgIcoNotify}>
                  <use xlinkHref="#ico-notify"></use>
                </svg>
              </div>
            </div> */}

            <div
              ref="menu"
              className={styles.hProfile}
              onClick={() => dispatch({ type: 'LITTLE_HEADER_MENU', isVisible: !isVisible })}
            >
              <p className={styles.hProfileName}>{fullName}</p>

              <div className={styles.hProfileAvatar}>
                <img className={styles.hProfileAvatarImg} src={avatar ? avatar : (gender === 'male' ? '/assets/img/png/boy.png' : '/assets/img/png/girl.png')} alt="" />
              </div>
              {/*<span className={!isVisible ? styles.caret : styles.caretActive}></span>*/}

              {isVisible && <ul
                className={styles.dropdownProfile}
              >
                { !isFirstEdit && <li className={styles.dropdownItem}>
                    <Link to="/profile">{fullName}</Link>
                  </li>
                }

                { !isFirstEdit && <li className={styles.dropdownSeparate}></li>}
                
                <li className={styles.dropdownItem}>
                  <a
                    href="#"
                    onClick={e => {
                      e.preventDefault()
                      cookie.remove('token', { path: '/' })
                      cookie.remove('txId', { path: '/' })
                      cookie.remove('role', { path: '/' })
                      cookie.remove('program', { path: '/' })
                      cookie.remove('packageType', { path: '/' })
                      cookie.remove('promoName', { path: '/' })
                      cookie.remove('share', { path: '/' })
                      cookie.remove('general', { path: '/' })
                      cookie.remove('userProgram', { path: '/' })
                      cookie.remove('tester', { path: '/' })
                      browserHistory.push('/')
                    }
                  }
                >
                  Выход
                </a>
                </li>
              </ul>}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { isVisible, userInfo, sign } = state
  return { isVisible, userInfo, sign }
}

HeaderTask = connect(
  mapStateToProps
)(HeaderTask)

export default CSSModules(HeaderTask, styles)



// WEBPACK FOOTER //
// /var/www/build-lk-1/src/components/componentKit2/HeaderTask.js